import React from 'react';
import { Check, X } from 'lucide-react';
import { useT } from '../context/LanguageContext';

// Vergelijkingstabel gebruikt op /pricing én in Instellingen → Plannen.
const ROWS = [
  { label: 'RDW-kentekencheck', basic: true, pro: true, ent: true },
  { label: 'Offertes & facturen', basic: true, pro: true, ent: true },
  { label: 'APK-herinneringen', basic: true, pro: true, ent: true },
  { label: 'Onbeperkt klanten & bonnen', basic: false, pro: true, ent: true },
  { label: 'Online afspraken (24/7)', basic: false, pro: true, ent: true },
  { label: 'Volledige boekhouding', basic: false, pro: true, ent: true },
  { label: 'Cloud back-up', basic: false, pro: true, ent: 'nachtelijk' },
  { label: '🌍 AI-meertaligheid', basic: false, pro: true, ent: true },
  { label: 'Gebruikers', basic: '1', pro: '5', ent: '25' },
];

function Cell({ v, t }) {
  if (v === true) return <Check size={16} color="#10b981" aria-label="ja" />;
  if (v === false) return <X size={16} color="#cbd5e1" aria-label="nee" />;
  if (v === 'nachtelijk') return <span style={{ fontSize: 11, color: '#10b981', fontWeight: 600 }}>{t('Nachtelijk', 'Nachtelijk')}</span>;
  return <span style={{ fontWeight: 700, color: '#0f172a' }}>{v}</span>;
}

export default function PlanComparison() {
  const { t } = useT();
  return (
    <div data-testid="plan-comparison" style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 6px rgba(15,23,42,.04)' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
        <thead>
          <tr style={{ background: '#f8fafc' }}>
            <th style={{ textAlign: 'left', padding: '12px 16px', color: '#64748b', fontWeight: 600 }}>{t('Functie', 'Functie')}</th>
            <th style={{ padding: '12px 8px', color: '#7c3aed', fontWeight: 700 }}>Basic</th>
            <th style={{ padding: '12px 8px', color: '#2563eb', fontWeight: 700 }}>Pro</th>
            <th style={{ padding: '12px 8px', color: '#0f172a', fontWeight: 700 }}>Enterprise</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r, i) => (
            <tr key={i} style={{ borderTop: '1px solid #f1f5f9' }} data-testid={`compare-row-${i}`}>
              <td style={{ padding: '11px 16px', color: '#334155' }}>{t(r.label, r.label)}</td>
              <td style={{ padding: '11px 8px', textAlign: 'center' }}><Cell v={r.basic} t={t} /></td>
              <td style={{ padding: '11px 8px', textAlign: 'center', background: '#eff6ff' }}><Cell v={r.pro} t={t} /></td>
              <td style={{ padding: '11px 8px', textAlign: 'center' }}><Cell v={r.ent} t={t} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
